import React from "react";
import SignUpCard from "./SignUpCard";

const SignupBar = () => {
  return <SignUpCard image="/static/img/Card-RegisterToExplore.png" imageTitle="Signup" title="Signup" />;
};

export default SignupBar;
